import { X } from 'lucide-react';
import { createElement, type CSSProperties } from 'react';

import {
  financeIconChoices,
  getFinanceIcon,
} from './financeAppearance';
import { EntityColorPicker } from './EntityColorPicker';

export function FinanceAppearanceEditor({
  icon,
  color,
  onIconChange,
  onColorChange,
  onDone,
}: {
  icon: string;
  color: string;
  onIconChange: (icon: string) => void;
  onColorChange: (color: string) => void;
  onDone: () => void;
}) {
  return (
    <div className="appearance-screen" role="presentation">
      <section
        className="appearance-dialog"
        role="dialog"
        aria-modal="true"
        aria-label="Выбор иконки"
      >
        <header className="appearance-header">
          <span />
          <h2>Выбор иконки</h2>
          <button type="button" aria-label="Закрыть выбор иконки" onClick={onDone}>
            <X size={25} />
          </button>
        </header>
        <div className="appearance-content">
          <span className="appearance-preview" style={{ background: color }}>
            {createElement(getFinanceIcon(icon), {
              size: 39,
              strokeWidth: 2.1,
            })}
          </span>

          <EntityColorPicker value={color} onChange={onColorChange} />

          <h3>Иконка</h3>
          <div className="appearance-icon-grid">
            {financeIconChoices.map(([candidate, label]) => (
              <button
                type="button"
                key={candidate}
                aria-label={`Выбрать иконку ${label}`}
                aria-pressed={candidate === icon}
                style={{ '--appearance-color': color } as CSSProperties}
                onClick={() => onIconChange(candidate)}
              >
                {createElement(getFinanceIcon(candidate, 'other'), {
                  size: 23,
                  strokeWidth: 2.2,
                })}
              </button>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
